import { Route, Switch, Redirect } from "wouter";
import { Login } from "./routes/Login";
import { AppShell } from "./routes/AppShell";

export function App() {
  return (
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/app/:rest*" component={AppShell} />
      <Route path="/app" component={() => <Redirect to="/app/dashboard" />} />
      <Route path="/" component={() => <Redirect to="/app/dashboard" />} />
      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
}

function NotFound() {
  return (
    <main className="min-h-[100dvh] grid place-items-center px-6 bg-app-bg">
      <div className="text-center space-y-3">
        <h1 className="text-2xl text-ink">Page not found</h1>
        <a href="/app/dashboard" className="text-accent-ink hover:underline">
          Go home
        </a>
      </div>
    </main>
  );
}
